import React from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import {useTable} from 'components/organisms/Providers/TableProvider/TableProvider';
import StyledCollectionEntitiesAssistantWrapper
  from 'components/templates/Wrappers/Collections/CollectionEntitiesAssistantWrapper/CollectionEntitiesAssistantWrapper.styles';
import CollectionEntitiesAssistant
  from 'components/organisms/Assistants/CollectionEntitiesAssistant/CollectionEntitiesAssistant';

const CollectionEntitiesAssistantWrapper = React.forwardRef((props, ref) => {
  const innerProps = useComponentProps(props, 'CollectionEntitiesAssistantWrapper');

  const tableProvider = useTable();

  return <StyledCollectionEntitiesAssistantWrapper ref={ref} {...innerProps}
                                                   variant="foldout"
                                                   context={<CollectionEntitiesAssistant />}
                                                   open={Boolean(tableProvider.state?.showAssistant)}
                                                   size="oversize"
                                                   ContextDrawerProps={{
                                                     onToggle: (e, open) => {
                                                       if (open) {
                                                         tableProvider.openAssistant();
                                                       } else {
                                                         tableProvider.closeAssistant();
                                                       }
                                                     }
                                                   }}>
    {innerProps.children}
  </StyledCollectionEntitiesAssistantWrapper>
});

CollectionEntitiesAssistantWrapper.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ])
};

export default CollectionEntitiesAssistantWrapper;
